/* ILY LOVEWEAR -- Header JS
   Dropdowns desktop (hover) + flyout mobile */

(function () {
  'use strict';

  const header = document.getElementById('ily-header');
  const dropdowns = document.querySelectorAll('.ily-dropdown');
  const flyout = document.getElementById('ily-flyout');

  /* ---- Dropdown: hover on desktop ---- */
  let closeTimer = null;

  function openDropdown(handle) {
    clearTimeout(closeTimer);
    dropdowns.forEach(d => d.classList.remove('is-open'));
    document.querySelectorAll('[data-dropdown]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    const target = document.getElementById('drop-' + handle);
    const btn = document.querySelector('[data-dropdown="' + handle + '"]');
    if (target) {
      target.classList.add('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }
  }

  function closeAll() {
    closeTimer = setTimeout(function () {
      dropdowns.forEach(d => d.classList.remove('is-open'));
      document.querySelectorAll('[data-dropdown]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    }, 80);
  }

  document.querySelectorAll('[data-dropdown]').forEach(btn => {
    btn.addEventListener('mouseenter', function () { openDropdown(this.dataset.dropdown); });
    btn.addEventListener('mouseleave', function () { closeAll(); });
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const target = document.getElementById('drop-' + this.dataset.dropdown);
      const isOpen = target && target.classList.contains('is-open');
      if (isOpen) {
        dropdowns.forEach(d => d.classList.remove('is-open'));
        document.querySelectorAll('[data-dropdown]').forEach(b => b.setAttribute('aria-expanded', 'false'));
      } else {
        openDropdown(this.dataset.dropdown);
      }
    });
  });

  dropdowns.forEach(drop => {
    drop.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    drop.addEventListener('mouseleave', function () { closeAll(); });
  });

  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) {
      dropdowns.forEach(d => d.classList.remove('is-open'));
      document.querySelectorAll('[data-dropdown]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      dropdowns.forEach(d => d.classList.remove('is-open'));
      document.querySelectorAll('[data-dropdown]').forEach(b => b.setAttribute('aria-expanded', 'false'));
      if (flyout) closeFlyout();
    }
  });

  /* ---- Flyout mobile ---- */
  function openFlyout() {
    if (!flyout) return;
    flyout.classList.add('is-open');
    flyout.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeFlyout() {
    if (!flyout) return;
    flyout.classList.remove('is-open');
    flyout.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  const hamburger = document.querySelector('[data-action="open-flyout"]');
  if (hamburger) hamburger.addEventListener('click', openFlyout);

  const closeBtn = document.querySelector('[data-action="close-flyout"]');
  if (closeBtn) closeBtn.addEventListener('click', closeFlyout);

  document.querySelectorAll('[data-flyout-toggle]').forEach(btn => {
    btn.addEventListener('click', function () {
      const sub = document.getElementById('flyout-' + this.dataset.flyoutToggle);
      if (sub) sub.hidden = !sub.hidden;
    });
  });

  const style = document.createElement('style');
  style.textContent = `
    .ily-flyout__sub { list-style:none; padding:0 0 8px 16px; }
    .ily-flyout__sub-link {
      display:block; font-family:var(--ily-sans); font-size:11px;
      font-weight:300; color:var(--ily-bark); padding:6px 0;
      letter-spacing:.06em; transition:color .15s;
    }
    .ily-flyout__sub-link:hover { color:var(--ily-night); }
  `;
  document.head.appendChild(style);

})();
